import { Point } from './carousel.types';

export const getMaxScale = (slideEl: HTMLElement): number => {
  const img = slideEl.querySelector<HTMLImageElement>('img');

  if (!img || !img.naturalWidth || !img.naturalHeight) {
    return 4;
  }

  const imageAspect = img.naturalWidth / img.naturalHeight;
  const containerAspect = slideEl.offsetWidth / slideEl.offsetHeight;
  const aspectRatio = imageAspect / containerAspect;
  const baseScale = img.naturalWidth / slideEl.offsetWidth;
  const maxScale = baseScale * Math.max(1, aspectRatio);

  return Math.max(2, maxScale);
};

export const getSwipePanel = (root: HTMLElement) =>
  root.querySelector<HTMLElement>('[data-carousel-panel]');

export const getSlide = (root: HTMLElement, index: number) =>
  root.querySelector<HTMLElement>(`[data-carousel-slide="${index}"]`);

export const getDist = (a: Point, b: Point) => Math.hypot(a.x - b.x, a.y - b.y);

export const getMid = (a: Point, b: Point): Point => ({
  x: (a.x + b.x) / 2,
  y: (a.y + b.y) / 2,
});

export const clampOrigin = (
  el: HTMLElement,
  x: number,
  y: number,
  s: number
): Point => {
  const maxX = (el.offsetWidth * (s - 1)) / 2;
  const maxY = (el.offsetHeight * (s - 1)) / 2;

  return {
    x: Math.max(-maxX, Math.min(maxX, x)),
    y: Math.max(-maxY, Math.min(maxY, y)),
  };
};
